export const UserRole = {
  CEO: "0",
  Admin: "1",
  PCP: "2",
  Nurse: "3",
  CareManager: "4",
  CareCoordinator: "5",
  Billing: "6",
  Coder: "7",
  Reception: "8",
  Support: "9",
};

export const UserRoleName = {
  [UserRole.CEO]: "CEO",
  [UserRole.Admin]: "System Administrator",
  [UserRole.PCP]: "Physician",
  [UserRole.Nurse]: "Nurse",
  [UserRole.CareManager]: "Care Manager",
  [UserRole.CareCoordinator]: "Care Coordinator",
  [UserRole.Billing]: "Billing Specialist",
  [UserRole.Coder]: "Medical Coder",
  [UserRole.Reception]: "Reception",
  [UserRole.Support]: "Technical Support",
};

export const LocationId = {
  FortMyers: "1",
  FortPierce: "2",
  Immokalee: "3",
  Lehigh: "4",
  Naples: "5",
  LakeWorth: "6",
  PortSaintLucie: "7",
  Unassigned: "8",
  Unknown: "0"
};

export const LocationName = {
  [LocationId.FortMyers]: "Fort Myers",
  [LocationId.FortPierce]: "Fort Pierce",
  [LocationId.Immokalee]: "Immokalee",
  [LocationId.Lehigh]: "Lehigh",
  [LocationId.Naples]: "Naples",
  [LocationId.LakeWorth]: "Lake Worth",
  [LocationId.PortSaintLucie]: "Port Saint Lucie",
  [LocationId.Unassigned]: "Unassigned",
  [LocationId.Unknown]: "FortMyers"
};
